import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const labeledDataSlotRecipe = defineSlotRecipe({
  className: 'labeled-data',
  slots: ['root', 'label', 'value', 'limit', 'helpText'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4',
    },
    label: {
      display: 'inline-flex',
      gap: '4',
      alignItems: 'center',
      textStyle: 'body/md/semibold',
    },
    value: {
      display: 'inline-flex',
      alignItems: 'baseline',
      gap: '2',
      fontFeatureSettings: 'pnum',
      fontVariantNumeric: 'proportional-nums',
    },
    limit: {
      color: 'text/secondary',
      fontWeight: 'initial',
      letterSpacing: 'initial',
    },
    helpText: {
      textStyle: 'body/md/regular',
      color: 'text/tertiary',
    },
  },
  variants: {
    size: {
      lg: {
        label: { color: 'text/primary' },
        value: { textStyle: 'comp/data/sm' },
        limit: { textStyle: 'body/md/regular' },
      },
      '2xl': {
        label: { color: 'text/secondary' },
        value: { textStyle: 'comp/data/md' },
        limit: { textStyle: 'body/xl/regular' },
      },
      '3xl': {
        label: { color: 'text/secondary' },
        value: { textStyle: 'comp/data/lg' },
        limit: { textStyle: 'body/2xl/regular' },
      },
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

export default labeledDataSlotRecipe;
